// extracted by mini-css-extract-plugin
module.exports = {"campaigns":"index_page_campaigns__1ns8_","listing":"index_page_listing__w3sOL"};